import { gql } from "@apollo/client";

export const fetchTargetRates = gql`
  query FetchTargetRates($targetId: ID!) {
    fetchTargetRates(target_id: $targetId) {
      id
      target_id
      rate_value
      currency_code
      currency
    }
  }
`;

export const fetchTargetRate = gql`
  query FetchTargetRate($targetRateId: ID!) {
    fetchTargetRate(target_rate_id: $targetRateId) {
      id
      rate_value
      currency_code
      currency
    }
  }
`;
